import React from "react";
import { cls } from "cls";
import {
  FeatureImageStyle,
  FeatureItemModel,
  LinkStyle,
} from "../Models/PageCreatorPage";
import ContainerWrapper from "./ContainerWrapper";
import LeadGenFeatureItemContainer from "./LeadGenFeatureItemContainer";

interface LeadGenFeatureGridProps {
  imageStyle: FeatureImageStyle;
  items: FeatureItemModel[];
  linkStyle: LinkStyle;
  hasDropshadow: boolean;
  hasOutline: boolean;
  containerColor: string;
  outlineColor: string;
  hasRoundedBorder: boolean;
}

const LeadGenFeatureGrid = ({
  imageStyle,
  items,
  linkStyle,
  hasDropshadow,
  hasOutline,
  containerColor,
  outlineColor,
  hasRoundedBorder,
}: LeadGenFeatureGridProps): JSX.Element => {
  return (
    <div
      className={cls(
        "flex",
        "flex-col",
        "space-y-6",
        "sm:space-y-0",
        "sm:grid",
        "sm:gap-6",
        "sm:grid-cols-2",
      )}
    >
      {items.map((item) => (
        <ContainerWrapper
          hasContainer
          hasDropShadow={hasDropshadow}
          hasOutline={hasOutline}
          containerColor={containerColor}
          containerOutlineColor={outlineColor}
          key={item.header}
          hasRoundedBorder={hasRoundedBorder}
        >
          <LeadGenFeatureItemContainer
            imageStyle={imageStyle}
            item={item}
            linkStyle={linkStyle}
          />
        </ContainerWrapper>
      ))}
    </div>
  );
};

export default LeadGenFeatureGrid;
